import {
    TextField,
    FormControl,
    InputLabel,
    Select,
    SelectChangeEvent,
    MenuItem,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
} from "@mui/material";
import React, { ChangeEvent, useEffect, useRef } from "react";
import { Role, Status } from "../../redux/userRoleList/state";
import styles from "./User.module.css";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import { UserFormInputType } from "../../interface/form";
import { axiosAPIWithJson } from "../../util/axios";
import { initUserRoleListThunk } from "../../redux/userRoleList/thunk";
import {
    inputFormPasswordThunk,
    inputFormRepeatPasswordThunk,
    inputFormUsernameThunk,
    changeRoleThunk,
    selectedUserStatusThunk,
    inputFormEmailThunk,
    inputFormTruckThunk,
} from "../../redux/user/thunk";

function UserForm() {
    const { roleList } = useSelector((state: IRootState) => state.userRoleList);
    const {
        username,
        password,
        repeatPassword,
        role,
        email,
        truck,
        selectedUser,
        status,
    } = useSelector((state: IRootState) => state.userFormState);
    const dataFetchedRef = useRef(false);

    const dispatch = useDispatch<IRootThunkDispatch>();
    function handleUserForm(
        event:
            | ChangeEvent<HTMLInputElement>
            | SelectChangeEvent<Role>
            | SelectChangeEvent<Status>,
        type: UserFormInputType
    ) {
        switch (type) {
            case "username":
                dispatch(inputFormUsernameThunk(event.target.value as string));
                break;

            case "password":
                dispatch(inputFormPasswordThunk(event.target.value as string));
                break;

            case "repeatPassword":
                dispatch(
                    inputFormRepeatPasswordThunk(event.target.value as string)
                );
                break;
            case "role":
                dispatch(changeRoleThunk(event.target.value as Role));
                break;
            case "email":
                dispatch(inputFormEmailThunk(event.target.value as string));
                break;
            case "truck":
                dispatch(inputFormTruckThunk(event.target.value as string));
                break;
            case "status":
                dispatch(selectedUserStatusThunk(event.target.value as Status));
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        const controller = new AbortController();
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        getRoleList();
        return () => {
            controller.abort();
        };
    }, [dispatch]);

    async function getRoleList() {
        const result = await axiosAPIWithJson.get(`/api/role`);
        if (result.data.success === true) {
            dispatch(initUserRoleListThunk(result.data.roleList));
            return;
        }
        return;
    }

    return (
        <div className={styles.user_outer_container}>
            <TextField
                required
                id="standard-helperText"
                label="用戶名稱"
                variant="standard"
                value={username}
                onChange={(event) =>
                    handleUserForm(
                        event as ChangeEvent<HTMLInputElement>,
                        "username"
                    )
                }
            />
            <TextField
                required
                id="standard-helperText"
                label="密碼"
                variant="standard"
                value={password}
                onChange={(event) =>
                    handleUserForm(
                        event as ChangeEvent<HTMLInputElement>,
                        "password"
                    )
                }
            />

            <TextField
                required
                id="standard-helperText"
                label="重覆密碼"
                variant="standard"
                value={repeatPassword}
                onChange={(event) =>
                    handleUserForm(
                        event as ChangeEvent<HTMLInputElement>,
                        "repeatPassword"
                    )
                }
            />

            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-standard-label">
                    角色
                </InputLabel>
                <Select
                    labelId="demo-simple-select-standard-label"
                    required
                    id="demo-simple-select-standard"
                    value={role}
                    label="角色"
                    onChange={(event) =>
                        handleUserForm(event as SelectChangeEvent<Role>, "role")
                    }
                >
                    <MenuItem value="">
                        <em>None</em>
                    </MenuItem>
                    {roleList?.map((list) => (
                        <MenuItem
                            value={list.role_id}
                            key={`role-${list.role_id}`}
                        >
                            {list.role}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {role == "6" && (
                <TextField
                    id="standard-helperText"
                    label="車牌號碼"
                    variant="standard"
                    value={truck}
                    onChange={(event) =>
                        handleUserForm(
                            event as ChangeEvent<HTMLInputElement>,
                            "truck"
                        )
                    }
                />
            )}

            {role == "7" && (
                <TextField
                    id="standard-helperText"
                    label="電郵地址"
                    variant="standard"
                    value={email}
                    onChange={(event) =>
                        handleUserForm(
                            event as ChangeEvent<HTMLInputElement>,
                            "email"
                        )
                    }
                />
            )}

            {selectedUser ? (
                <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                        用戶狀態
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={status}
                        onChange={(event) =>
                            handleUserForm(
                                event as SelectChangeEvent<Status>,
                                "status"
                            )
                        }
                    >
                        <FormControlLabel
                            value={0}
                            control={<Radio />}
                            label="已關閉"
                        />
                        <FormControlLabel
                            value={1}
                            control={<Radio />}
                            label="正使用"
                        />
                    </RadioGroup>
                </FormControl>
            ) : (
                <></>
            )}
        </div>
    );
}

export default UserForm;
